export default __webpack_public_path__ + "static/media/endangeredInsects.f6599053.webp";